import { useRouter } from '@tanstack/react-router';

interface ReturnType {
  navigateBack: (fallbackUrl: string) => void;
}

export const useNavigateBack = (): ReturnType => {
  const { history } = useRouter();

  const navigateBack = (fallbackUrl: string) => {
    if (history.canGoBack()) {
      return history.back();
    } else {
      return history.push(fallbackUrl);
    }
  };

  return { navigateBack };
};
